import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  padding: ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const InternalIdContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 10px;
  padding-right: ${props => props.theme.spacing.sp16};
  margin-right: ${props => props.theme.spacing.sp16};
  border-right: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  width: 100%;
`

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const TitleContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
`

export const ActionLabel = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
`

export const TagsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  flex-wrap: wrap;
`
